<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0"></div>
<p class="calibre3"><span id="pgepubid00035" title="[26]"><a id="Page_26" title="[26]"></a></span></p>
<h2 class="calibre" id="pgepubid00036">CHAPTER III.<br class="calibre16"/>
<span class="cheaderfont">TSARINA OLGA.</span></h2>
<p class="pcalibre drop-capi-m">THREE days after his death, the body of Paul
Romanoff was reduced to ashes in the Highgate
Crematorium, a magnificent building, in the
sombre yet splendid architecture of ancient
Egypt, which stood in the midst of what had
once been Highgate Cemetery, and what was now a beautiful
garden, shaded by noble trees, and in summer ablaze with
myriads of flowers.</p>
<p class="calibre3">Not a grave or a headstone was to be seen, for burial in the
earth had been abolished throughout the civilised world for
nearly a century. In the vast galleries of the central building,
thousands of urns, containing the ashes of the dead, reposed in
niches inscribed with the name and date of death, but these
mostly belonged to the poorer classes, for the wealthy as a rule
devoted a chamber in their own houses to this purpose.</p>
<p class="calibre3">The body was registered in the great Book of the Dead at
the Crematorium as that of Paul Ivanitch, and the only two
mourners signed their names, “Serge Ivanitch and Olga
Ivanitch, grand-children of the deceased.” The reason for this
was, that for more than a century the name of Romanoff had
been proscribed in all the nations of Europe. It was believed
that the Vladimir Romanoff who had been executed by the
Supreme Council, for attempting to solve the forbidden problem,
was the last of his race, and Paul had taken great pains not to
disturb this belief.</p>
<p class="calibre3"><span id="pgepubid00037" title="[27]"><a id="Page_27" title="[27]"></a></span></p>
<p class="calibre3">Long before his son had met with his end, he had called
himself Paul Ivanitch, and settled in London and practised his
profession as a sculptor, in which he had won both fame and
fortune. Olga had lived with him since her father’s death,
and Serge, who at the time the narrative opens had just completed
his studies at the Art University of Rome, had passed
as her brother.</p>
<p class="calibre3">They took the urn containing the ashes of the old man back
with them to the house, which now belonged, with all its contents,
to Olga and Serge. On the morning after his death, a
notice, accompanied by an abstract of his will, had been inserted
in <cite class="calibre14">The Official Gazette</cite>, the journal devoted exclusively
to matters of law and government.</p>
<p class="calibre3">Paul Romanoff had, however, left two wills behind him,
one which had to be made public in compliance with the law,
and one which was intended only for the eyes of Olga and
Serge. This second will reposed, with the crown of Russia, in
the secret recess in the wall of the octagonal chamber; and the
instructions endorsed upon it stated that it was to be opened
by Serge in the presence of Olga, after they had brought his
ashes back to the house and had been legally confirmed in their
possession of his property.</p>
<p class="calibre3">Consequently, on the evening of the 11th, the two shut
themselves into the room, and Olga, who since her grandfather’s
death had worn the key of the recess on a chain
round her neck, unlocked the secret door and gave the will
to Serge. As she did so, a sudden fancy seized her. She took
the crown from its resting-place, and, standing in front of
a long mirror which occupied one of the eight sides of the
room from roof to floor, poised it above the lustrous coils of
her hair with both hands, and said, half to Serge and half to
herself—</p>
<p class="calibre3">“What age could not accomplish, youth shall do! By my
own right, and with my own hands, I am crowned Tsarina,
Empress of the Russias in Europe and Asia. As the great
Catherine was, so will I be—and more, for I will be Mistress of
the West and the East. I will have kings for my vassals and<span id="pgepubid00038" title="[28]"><a id="Page_28" title="[28]"></a></span>
senates for my servants, and I will rule as no other woman has
ruled before me since Semiramis!”</p>
<p class="calibre3">As she uttered the daring words, whose fulfilment seemed
beyond the dreams of the wildest imagination, she placed the
crown upon her brow and stood, clothed in imperial purple
from head to foot, the very incarnation of loveliness and royal
majesty. Serge looked up as she spoke, and gazed for a
moment entranced upon her. Then he threw himself upon his
knees before her, and, raising the hem of her robe to his lips,
said in a voice half choked with love and passion—</p>
<p class="calibre3">“And I, who am also of the imperial blood, will be the first
to salute you Tsarina and mistress! You have taken me as
your lover, let me also be the first of your subjects. I will
serve you as woman never was served before. You shall be
my mistress—my goddess, and your words shall be my laws
before all other laws. If you bid me do evil, it shall be to me
as good, and I will do it. I will kill or leave alive according
to your pleasure, and I will hold my own life as cheap as
any other in your service; for I love you, and my life is
yours!”</p>
<p class="calibre3">Olga looked down upon him with the light of triumph in
her eyes. No woman ever breathed to whom such words
would not have been sweet; but to her they were doubly sweet,
because they were a spontaneous tribute to the power of her
beauty and the strength of her royal nature, and an earnest of
her future sway over other men.</p>
<p class="calibre3">More than this, too, they had been won without an effort,
from the lips of the man whom she had always been taught to
look upon as higher than other men, in virtue of his descent
from her own ancestry, and the blood-right that he shared with
her to that throne which it was to be their joint life-task to
re-establish.</p>
<p class="calibre3">If she did not love him, it was rather because ambition and
the inborn lust of power engrossed her whole being, than from
any lack of worthiness on his part. Of all the men she had
ever seen, none compared with him in strength and manliness
save one—and he, bitter beyond expression as the thought was<span id="pgepubid00039" title="[29]"><a id="Page_29" title="[29]"></a></span>
to her, was so far above her as she was now, that he seemed to
belong to another world and to another order of beings.</p>
<p class="calibre3">As their eyes met, a thrill that was almost akin to love
passed through her soul, and, acting on the impulse of the
moment, she took the crown from her own head and held it
above his as he knelt at her feet, and said—</p>
<p class="calibre3">“Not as my subject or my servant, but as my co-ruler and
helpmate, you shall keep that oath of yours, Serge Nicholaivitch.
We have exchanged our vows, and in a few days I shall be
your wife. We will wed as equals; and so now I crown you,
as it is my right to do. Rise, my lord the Tsar, and take your
crown!”</p>
<p class="calibre3">Serge put up his hands and took the crown from hers at
the moment that she placed it on his brow. He rose to his
feet, holding it on his head as he said solemnly—</p>
<p class="calibre3">“So be it, and may the God of our fathers help me to wear
it worthily with you, and to restore to it the glory that has
been taken from it by our enemies!”</p>
<p class="calibre3">Then he laid it reverently down on the table and turned to
Olga, who was still standing before the mirror looking at her
own lovely image, as though in a dream of future glory. He
took her unresisting in his arms, and kissed her passionately
again and again, bringing the bright blood to her cheeks and the
light of a kindred passion to her eyes, and murmuring between
the kisses—</p>
<p class="calibre3">“But you, darling, are worth all the crowns of earth, and I
am still your slave, because your beauty and your sweetness
make me so.”</p>
<p class="calibre3">“Then slave you shall be!” she said, giving him back kiss
for kiss, well knowing that with every pressure of her intoxicating
lips she riveted the chains of his bondage closer upon
his soul.</p>
<p class="calibre3">To an outside observer, what had taken place would have
seemed but little better than boy-and-girl’s play, the phantasy
of two young and ardent souls dreaming a romantic and
impossible dream of power and glory that had vanished, never
to be brought back again. And yet, if such a one had been<span id="pgepubid00040" title="[30]"><a id="Page_30" title="[30]"></a></span>
able to look forward through little more than a single lustrum,
he would have seen that, in the mysterious revolutions of
human affairs, it is usually the seemingly impossible that
becomes possible, and the most unexpected that comes to
pass.</p>
<p class="calibre3">The secret will of Paul Romanoff, to the study of which the
two lovers addressed themselves when they awoke from the
dream of love and empire into which Olga’s phantasy had
plunged them both, would, if it had been made public, have
given a by no means indefinite shape to such vague dreams of
world-revolution as were inspired in thoughtful minds, even in
the thirty-first year of the twenty-first century.</p>
<p class="calibre3">It was a voluminous document of many pages, embodying
the result of nearly eighty years of tireless scheming and
patient research in the field of science as well as in that of
politics. Paul Romanoff had lived his life with but one object,
and that was, to prepare the way for the accomplishment of a
revolution which should culminate in the subversion of the
state of society inaugurated by the Terrorists, and the re-establishment,
at anyrate in the east of Europe, of autocratic rule in
the person of a scion of the House of Romanoff. All that he
had been able to do towards the attainment of this seemingly
impossible project was crystallised in the document bequeathed
to Olga and Serge.</p>
<p class="calibre3">It was divided into three sections. The first of these was
mostly of a personal nature, and contained details which it
would serve no purpose of use or interest to reproduce here.
It will therefore suffice to say, that it contained a list of the
names and addresses of four hundred men and women scattered
throughout Europe and America, each of whom was the
descendant of some prince or noble, some great landowner
or millionaire, who had suffered degradation or ruin at the
hands of the Terrorists during the reorganisation of society,
after the final triumph of the Anglo-Saxon Federation in
1904.</p>
<p class="calibre3">The second section of the will was of a purely scientific and
technical character. It was a theoretical arsenal of weapons<span id="pgepubid00041" title="[31]"><a id="Page_31" title="[31]"></a></span>
for the arming of those who, if they were to succeed at all, could
only do so by bringing back that which it had cost such an
awful expenditure of blood and suffering to banish from the
earth in the days of the Terror. The designs of Paul Romanoff,
and the vast aspirations of those to whom he had bequeathed
the crown of the great Catherine, could have but one
result if they ever passed from the realm of fancy to that of
deeds.</p>
<p class="calibre3">If the clock was to be put back, only the armed hand could
do it, and that hand must be so armed that it could strike at
first secretly, and yet with paralysing effect. The few would
have to array themselves against the many, and if they
triumphed, it would have to be by the possession of some such
means of terrorism and irresistible destruction as those who
had accomplished the revolution of 1904 had wielded in their
aerial fleet.</p>
<p class="calibre3">By far the most important part of this section of the will
consisted of plans and diagrams of various descriptions of air-ships
and submarine vessels, accompanied by minute directions
for building and working them. Most of these were from the
hand of Vladimir Romanoff, Olga’s father; but of infinitely
more importance even than all these was a detailed description,
on the last page but two of the section, of the solution of a
problem which had been attempted in the last decade of the
nineteenth century, but which was still unsolved so far as the
world at large was concerned.</p>
<p class="calibre3">This was the direct transformation of the solar energy
locked up in coal into electrical energy, without loss either by
waste or transference. How vast and yet easily controlled a
power this would be in the hands of those who were able to
wield it, may be guessed from the fact that, in the present day,
less than ten per cent. of the latent energy of coal is developed
as electrical power even in the most perfect systems of conversion.</p>
<p class="calibre3">All the rest is wasted between the furnace of the steam-engine
and the dynamo. It was to electrical power, obtained
direct from coal and petroleum, that Vladimir Romanoff trusted<span id="pgepubid00042" title="[32]"><a id="Page_32" title="[32]"></a></span>
for the motive force of his air-ships and submarine vessels, and
which he had already employed with experimental success as
regards the former, when his career was cut short by the
swift and pitiless execution of the sentence of the Supreme
Council.</p>
<p class="calibre3">The remainder of this section was occupied by a list of
chemical formulæ for the most powerful explosives then
known to science, and minute instructions for their preparation.
At the bottom of the page which contained these, there
was a little strip of parchment, fastened by one end to the
binding of the other sheets, and covered with very small
writing.</p>
<p class="calibre3">Olga’s eyes, wandering down over the maze of figures which
crowded the page, reached it before Serge’s did. One quick
glance told her that it was something very different to the rest.
She laid one hand carelessly over it, and with the other softly
caressed Serge’s crisp, golden curls. As he looked round in
response to the caress, their eyes met, and she said in her sweet,
low, witching voice—</p>
<p class="calibre3">“Dearest, I have a favour to ask of you.”</p>
<p class="calibre3">“Not a favour to ask, but a command to give, you mean.
Speak, and you are obeyed. Have I not sworn obedience?” he
replied, laying his hand upon her shoulder and drawing her
lovely face closer to his as he spoke.</p>
<p class="calibre3">“No, it is only a favour,” she said, with such a smile as
Antony might have seen on the lips of Cleopatra. “I want
you to leave me alone for a little time—for half an hour—and
then come back and finish reading this with me. You know
my brain is not as strong as yours, and I feel a little bewildered
with all the wonderful things that there are in this legacy of
my father’s father.</p>
<p class="calibre3">“Before we go any further, I should like to read it all
through again by myself, so as to understand it thoroughly.
So suppose you go to your smoking-room for a little, and leave
me to do so. I shall not take very long, and then we will go
over the rest together.”</p>
<p class="calibre3">“But we have only a couple more pages to read, sweet one,<span id="pgepubid00043" title="[33]"><a id="Page_33" title="[33]"></a></span>
and then I will go over it all again with you, and explain anything
that you have not understood.”</p>
<p class="calibre3">As he spoke, Serge’s eyes never wavered for a moment from
hers. Could he but have broken their spell, he might have seen
that she was hiding something from him under her little, white
hand and shapely arm. She brought her red, smiling lips still
nearer to his as she almost whispered in reply—</p>
<p class="calibre3">“Well, it is only a girl’s whim, after all, but still I am a
girl. Come, now, I will give you a kiss for twenty minutes’
solitude, and when you come back, and we have finished our
task, you shall have as many more as you like.”</p>
<p class="calibre3">The sweet, tempting lips came closer still, and the witching
spell of her great dusky eyes grew stronger as she spoke. How
was he to know what was hanging in the balance in that fateful
moment? He was but a hot-blooded youth of twenty, and he
worshipped this lovely, girlish temptress, who had not yet seen
seventeen summers, with an adoration that blinded him to all
else but her and her intoxicating beauty.</p>
<p class="calibre3">He drew her yielding form to him until he could feel her
heart beating against his, and as their lips met, the promised
kiss came from hers to his. He returned it threefold, and then
his arm slipped from her shoulder to her waist, and he lifted
her like a child from her chair, and carried her, half laughing
and half protesting, to the door, claimed and took another kiss
before he released her, and then put her down and left her alone
without another word.</p>
<p class="calibre3">“Alas, poor Serge!” she said, as the door closed behind him;
“you are not the first man who has lost the empire of the world
for a woman’s kiss. Before, I saw that you were my equal and
helpmate, now you and all other men—yes, not even excepting
he who seems so far above me now—shall be my slaves and do
my bidding, so blindly that they shall not even know they are
doing it.</p>
<p class="calibre3">“Yes, the weapons of war are worth much, but what are
they in comparison with the souls of the men who will have
to use them!”</p>
<p class="calibre3">In half an hour Serge came back to finish the reading of<span id="pgepubid00044" title="[34]"><a id="Page_34" title="[34]"></a></span>
the will with her. The little slip of paper had been removed
so skilfully that it would have been impossible for him to have
even guessed that it had ever been attached to the parchment,
or that it was now lying hidden in the bosom of the girl who
would have killed him without the slightest scruple to gain the
unsuspected possession of it.</p>
<div class="figcenter3">
<img alt="" class="calibre13" id="id-2464461372510275183" src="Images/img0005.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?13e004eb